module.exports = __webpack_public_path__ + "golden-chorale-logo-3d.bd6dcc9.png";